import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const DashboardProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Vérifie si l'utilisateur est authentifié pour le dashboard
    const checkAuth = () => {
      const authStatus = sessionStorage.getItem('dashboardAuthenticated');
      setIsAuthenticated(authStatus === 'true');
      setIsLoading(false);
    };
    
    checkAuth();
  }, []);

  // Affiche un loader pendant la vérification
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirige vers la page d'authentification si non authentifié
  if (!isAuthenticated) {
    return <Navigate to="/dashboard-auth" state={{ from: location }} replace />;
  }

  // Si authentifié, affiche le contenu enfant
  return children;
};

export default DashboardProtectedRoute; 